import React, { useState, useRef, useEffect } from "react";
import contractIcon from "../../../assets/images/contractIcon.svg";
import { Loader } from "@thdinc/hpf-shared";

interface ContractCardProps {
    title: string;
    isDefault?: boolean;
    isLoading?: boolean;
    isSelected?: boolean;
    onEdit?: () => void;
    onDelete?: () => void;
    onSetDefault?: () => void;
}



export default function ContractCard({ isDefault, onEdit, onDelete, onSetDefault, title, isLoading, isSelected }: ContractCardProps) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    // Close menu on outside click
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div
            className={`relative w-full max-w-sm rounded-xl bg-white shadow-sm px-4 py-3 flex items-center justify-between border
  ${isSelected
                    ? "border-primary-red ring-1 ring-primary-red/30"
                    : "border-gray-200"
                }`}
        >
            {/* Left section */}
            <div className="flex items-center gap-3">
                <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center">
                    <img src={contractIcon} alt="Contract Icon" className="h-4 w-3" />
                </div>
                <span className="text-sm font-medium text-gray-800">
                    {title}
                </span>

            </div>

            {/* Menu */}
            <div className=" flex items-center gap-2">
                {/* Default badge */}
                {isDefault && <span className="ml-2 rounded-full bg-[#3ACB6126] px-[14px] py-[6px] text-xs font-medium text-[#3ACB61]">
                    Default
                </span>
                }
                <div className="relative" ref={menuRef}>
                    <>
                        {isLoading ?
                            <Loader color="bg-red-500" />
                            : <button
                                onClick={() => setOpen((prev) => !prev)}
                                className="p-1 rounded-full bg-gray-100 transition">
                                <svg
                                    className="w-5 h-5 text-gray-500"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M10 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z" />
                                </svg>
                            </button>}
                    </>
                    {/* Dropdown */}
                    {open && (
                        <div className="absolute right-0 mt-2 w-40 rounded-lg bg-white shadow-lg border z-50">
                            <button onClick={() => { onEdit?.(); setOpen((prev) => !prev) }} className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100">
                                Edit
                            </button>
                            <div className="border-t border-gray-200" />
                            <button onClick={() => { onDelete?.(); setOpen((prev) => !prev) }} className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100">
                                Delete
                            </button>
                            <div className="border-t border-gray-200" />
                            <button onClick={() => { onSetDefault?.(); setOpen((prev) => !prev) }} className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100">
                                Set as default
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
